import React from "react";
import CusInput from "../../../mui/custom_input/CusInput";
import IconPhone from "../../../mui/JSXIcons/IconPhone";

export default function InputPhone({
  placeholder = "Phone",
  name = "phone",
  inputRef,
  required = true,
  errorWarning,
  iconSourceEnd,
  sourceEndText,
  successInfo,
  value,
  autoFocus,
  onChange
}) {
  return (
    <CusInput
      cusInputRef={inputRef}
      value={value}
      onChange={onChange}
      name={name}
      placeholder={placeholder}
      autocomplete="tel"
      required={required}
      iconJSXstart={<IconPhone />}
      dataType={"tel"}
      errorWarning={errorWarning}
      successInfo={successInfo}
      iconSourceEnd={iconSourceEnd}
      sourceEndText={sourceEndText}
      autoFocus={autoFocus}
    />
  );
}
